import { useMutation } from '@apollo/client'
import { AddCompanyGroupMembers, AddCompanyGroupMembersVariables } from '../../types'
import { ADD_COMAPNY_GROUP_MEMBERS } from './operations'

interface Props {
  onCompleted?: () => void
  onError?: () => void
}

export const useAddCompanyGroupMembersMutation = (props?: Props) => {
  const { onCompleted, onError } = props || {}
  return useMutation<AddCompanyGroupMembers, AddCompanyGroupMembersVariables>(
    ADD_COMAPNY_GROUP_MEMBERS,
    {
      onCompleted,
      onError,
    }
  )
}
